import { TaskDetailsComponent } from "../tasks/task-details/task-details.component";
import { ThreatActorDetailsComponent } from "../threat-actor/threat-actor-details/threat-actor-details.component";
import { SearchComponent } from "./search.component";
import { CoaDetailsComponent } from '../coa/coa-details/coa-details.component';
import { TaskDocHistoryComponent } from "../tasks/task-doc-history/task-doc-history.component";

const SearchRoutes = [
  {
    path: "",
    component: SearchComponent,
  },
  {
    path: "task/:instanceId",
    data: { text: "Task", breadcrumbs: true },
    children: [
      { path: "",  component: TaskDetailsComponent},
      { path: "file-history/:documentId", component: TaskDocHistoryComponent, data: { text: "File History", breadcrumbs: true}}
    ]
  },
  {
    path: ":ta_id",
    data: {
      text: "threatActor_singular Details",
      breadcrumbs: true,
    },
    children: [
      {
        path: "",
        component: ThreatActorDetailsComponent,
      },
      {
        path: "task/:instanceId", component: TaskDetailsComponent,
        data: { text: "coa_singular Task", breadcrumbs: true },
      },
      {
        path: "coa/:id",
        component: CoaDetailsComponent,
        data: { text: "coa_singular", breadcrumbs: true },
      }
    ],
  }
];


export const SearchRoutingComponents = [
  SearchComponent,
];

export { SearchRoutes };
